import homeOld from '@/components/home/home-old/home-old.vue';
import trends from '@/components/home/trends/trends.vue';
import pageMarkets from '@/components/pages/page-markets/page-markets.vue';
import pageMarketDetail from '@/components/pages/page-market-detail/page-market-detail.vue';
import pageStoryDetail from '@/components/pages/page-story-detail/page-story-detail.vue';
import pageSearch from '@/components/pages/page-search/page-search.vue';
import pageWatchlist from '@/components/pages/page-watchlist/page-watchlist.vue';
import pagePrivacyPolicy from '@/components/pages/page-privacy-policy/page-privacy-policy.vue';
import pageTermsAndConditions from '@/components/pages/page-terms-and-conditions/page-terms-and-conditions.vue';
import pagePlatformAnnouncements from '@/components/pages/page-platform-announcements/page-platform-announcements.vue';
import pageDebug from '@/components/pages/debug/debug.vue';
import pageSitemap from '@/components/pages/page-sitemap/page-sitemap.vue';
import pageResearch from '@/components/pages/page-research/page-research.vue';
import pageLeaderboards from '@/components/pages/page-leaderboards/page-leaderboards.vue';
import pageNotFound from '@/components/pages/page-not-found/page-not-found.vue';
import pageStaticPreview from '@/components/pages/page-static-preview/page-static-preview.vue';
import pageStoryPreview from '@/components/pages/page-story-preview/page-story-preview.vue';
import pageDailyMarketsDetails, { DAILY_PAGES } from '@/components/pages/page-daily-markets-details/page-daily-markets-details.vue';
import pageStories from '@/components/pages/page-stories/page-stories.vue';
import pageAccessibilityStatement
  from '@/components/pages/page-accessibility-statement/page-accessibility-statement.vue';
import pageUserStatus from '@/components/pages/page-user-status/page-user-status.vue';
// import insight from '@/components/insight/insight.vue';
import store from '@/store';
import log from '@/logger';
import accountRoutes from './account';
import supportRoutes from './support';
import dashboardRoutes from './dashboard';
import staticPages from './static';

const routes = [
  ...accountRoutes,
  ...supportRoutes,
  ...dashboardRoutes,
  ...staticPages,
  {
    path: '/',
    component: homeOld,
    name: 'home',
    // meta: {
    //   appContentFullWidth: true,
    // },
  },
  {
    path: '/trends',
    component: trends,
    name: 'trends',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/research',
    component: pageResearch,
    name: 'research',
  },
  {
    path: '/privacy-policy',
    component: pagePrivacyPolicy,
    name: 'privacy-policy',
  },
  {
    path: '/accessibility-statement',
    name: 'accessibility-statement',
    component: pageAccessibilityStatement,
  },
  {
    path: '/terms-and-conditions',
    component: pageTermsAndConditions,
    name: 'terms-and-conditions',
  },
  {
    path: '/platform-announcements',
    component: pagePlatformAnnouncements,
    name: 'platform-announcements',
  },
  {
    path: '/markets/search',
    name: 'market-search',
    component: pageSearch,
  },
  {
    path: '/markets/watchlist',
    name: 'market-watchlist',
    component: pageWatchlist,
    beforeEnter: (to, from, next) => {
      // browse.selectedOrder etc i shared by watchlist and markets page
      log.info('[WATCHLIST] Before enter setup');
      if (to.query.sortParameter) {
        store.dispatch('browse/setTimespanFromQuery', to.query.sortParameter);
      } else {
        store.dispatch('browse/setTimespanFromQuery', 'ALL');
      }
      if (to.query.sort) {
        store.dispatch('browse/setOrderFromQuery', to.query.sort);
      } else {
        store.dispatch('browse/setOrderFromQuery', 'traded');
      }
      next();
    },
  },
  {
    path: '/markets/detail/:marketId/:marketUrl?',
    name: 'market-details',
    component: pageMarketDetail,
    props: route => ({
      marketId: parseInt(route.params.marketId, 10),
      showRules: !!route.params.showRules,
      prerendered: route.query.prerendered,
    }),
  },
  {
    path: '/markets/:headerId?/:headerUrl?',
    name: 'market-list',
    component: pageMarkets,
    beforeEnter: (to, from, next) => {
      log.info('[MARKETS] Before enter setup');
      if (to.query.filterIds) {
        to.query.filterIds.split(',').forEach((i) => {
          const filterId = parseInt(i, 10);
          log.info(`[MARKETS] filterId passed: ${filterId}`);
          if (filterId) store.dispatch('browse/addFilter', filterId);
        });
      }
      if (to.query.sortParameter) {
        store.dispatch('browse/setTimespanFromQuery', to.query.sortParameter);
      }
      if (to.query.sort) {
        store.dispatch('browse/setOrderFromQuery', to.query.sort);
      }
      next();
    },
    props: route => ({
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl,
    }),
  },
  {
    path: '/stories/detail/:storyId/:storyUrl?',
    name: 'story-details',
    component: pageStoryDetail,
    props: route => ({
      storyId: parseInt(route.params.storyId, 10),
    }),
  },
  // {
  //   path: '/insight',
  //   name: 'insight',
  //   component: insight,
  // },
  // {
  //   path: '/insight/:slug',
  //   name: 'insight-detail',
  //   component: insight,
  //   props: true,
  // },
  {
    path: '/payment/success',
    component: pageMarkets,
    name: 'payment-success',
    props: route => ({
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl,
      notificationText: 'Bitcoin Deposit Received',
      notificationLevel: 'success',
    }),
  },
  {
    path: '/payment/fail',
    component: pageMarkets,
    name: 'payment-fail',
    props: route => ({
      headerId: parseInt(route.params.headerId, 10) || 0,
      headerUrl: route.params.headerUrl,
    }),
  },
  {
    path: '/static-page-preview',
    component: pageStaticPreview,
    name: 'static-page-preview',
    beforeEnter: (to, from, next) => {
      if (!to.query.previewId) {
        next({
          name: 'home',
        });
      } else {
        next();
      }
    },
    props: route => ({
      previewId: route.query.previewId,
    }),
  },
  {
    path: '/story-full-preview',
    component: pageStoryPreview,
    name: 'story-full-preview',
    beforeEnter: (to, from, next) => {
      if (!to.query.previewId) {
        next({
          name: 'home',
        });
      } else {
        next();
      }
    },
    props: route => ({
      previewId: route.query.previewId,
    }),
  },
  {
    path: DAILY_PAGES.MONDAY.path,
    component: pageDailyMarketsDetails,
    name: DAILY_PAGES.MONDAY.id,
    props: () => ({
      pageId: DAILY_PAGES.MONDAY.pageId,
    }),
  },
  {
    path: DAILY_PAGES.TUESDAY.path,
    component: pageDailyMarketsDetails,
    name: DAILY_PAGES.TUESDAY.id,
    props: () => ({
      pageId: DAILY_PAGES.TUESDAY.pageId,
    }),
  },
  {
    path: DAILY_PAGES.WEDNESDAY.path,
    component: pageDailyMarketsDetails,
    name: DAILY_PAGES.WEDNESDAY.id,
    props: () => ({
      pageId: DAILY_PAGES.WEDNESDAY.pageId,
    }),
  },
  {
    path: DAILY_PAGES.THURSDAY.path,
    component: pageDailyMarketsDetails,
    name: DAILY_PAGES.THURSDAY.id,
    props: () => ({
      pageId: DAILY_PAGES.THURSDAY.pageId,
    }),
  },
  {
    path: '/sitemap',
    component: pageSitemap,
    name: 'sitemap',
  },
  {
    path: '/user-status',
    component: pageUserStatus,
    name: 'user-status',
  },
  {
    path: '*',
    component: pageNotFound,
    name: 'not-found',
  },
];


if (process.env.NODE_ENV !== 'production') {
  routes.push({
    path: '/debug',
    component: pageDebug,
    name: 'debug',
  });
}

if (process.env.LEADERBOARDS_ENABLED) {
  routes.push({
    path: '/leaderboards',
    component: pageLeaderboards,
    name: 'leaderboards',
    beforeEnter: (to, from, next) => {
      log.info('[LEADERBOARDS] Before enter setup');
      if (typeof to.query.leaderboardId !== 'undefined') {
        log.info(`[LEADERBOARDS] settings leaderboardId: ${to.query.leaderboardId}`);
        store.dispatch('leaderboards/setSelectedLeaderboardId', parseInt(to.query.leaderboardId, 10));
      }
      if (to.query.dateRange) {
        log.info(`[LEADERBOARDS] settings dateRange: ${to.query.dateRange}`);
        store.dispatch('leaderboards/setLeaderboardsDateRange', parseInt(to.query.dateRange, 10));
      }
      next();
    },
  });
}

if (process.env.STORIES_PAGE_ENABLED) {
  routes.push({
    path: '/stories',
    component: pageStories,
    name: 'stories',
  });
}
export default routes;




// WEBPACK FOOTER //
// ./src/router/routes.js